/* eslint-disable */
import { modalActions } from "@/Actions";
import { Close } from "@mui/icons-material";
import { Modal } from "@mui/material";
import { useState } from "react";
import { connect } from "react-redux";

const OrderImagesModal = (props) => {
    const { show, data, toggleModal } = props 
    const [enlargedImage, setEnlargedImage] = useState(null);
    const handleImageClick = (image) => {
        setEnlargedImage(image);
      };
    
      const closeEnlargedImage = () => {
        setEnlargedImage(null);
      };
  return (
    <Modal
    open={show}
    onClose={() => toggleModal(false)}
    className='flex items-center justify-center p-4'
>
    <div className='bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-auto relative'>
        {/* Close Button */}
        <button
            onClick={() => toggleModal(false)}
            className='absolute top-4 right-4 z-10 text-gray-600 hover:text-gray-900'
        >
            <Close fontSize='large' />
        </button>

        {/* Modal Title - Now Sticky */}
        <h2 className='text-2xl font-bold p-6 pb-2 border-b sticky top-0 bg-white z-10'>
            Order Images
        </h2>

        {/* Image Grid */}
        <div className='p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
            {data?.orderImages?.map((image, index) => (
                <div
                    key={index}
                    className='border rounded-lg overflow-hidden shadow-md cursor-pointer'
                    onClick={() => handleImageClick(image)}
                >
                    {/* Image Header */}
                    <div className='bg-gray-100 px-3 py-1 font-semibold'>
                        <p className='text-sm'>{image?.name} {image?.variant ? " ("+image?.variant+")" : null}</p>
                        <p className='text-xs mt-0 text-gray-600'>
                            {image?.stageName}
                        </p>
                    </div>

                    {/* Image */}
                    <img
                        src={image.imageUrl}
                        alt={'item image'}
                        className='w-full h-64 object-cover'
                    />
                </div>
            ))}
        </div>

        {/* Enlarged Image View */}
        {enlargedImage && (
            <div className='fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50'>
                <div className='relative max-w-4xl w-full'>
                    <button
                        onClick={closeEnlargedImage}
                        className='absolute top-4 right-4 bg-white rounded-full p-1 shadow-lg text-gray-800 hover:text-gray-900'
                    >
                        <Close fontSize='large' />
                    </button>
                    <img
                        src={enlargedImage.imageUrl}
                        alt={
                            enlargedImage.itemName ||
                            'Enlarged image'
                        }
                        className='max-h-screen max-w-full object-contain'
                    />
                </div>
            </div>
        )}
    </div>
</Modal>
  )
}

const mapStateToProps = (state) => {
	const { show, data } = state.modal.orderImagesModal;
	// const address = state.form.MY_CUSTOMERS.data.VIEW;
	return {
		show,
		data,
	};
};

const mapDispatchToProps = {
	toggleModal: modalActions.toggleOrderImagesModal,
};
export default connect(mapStateToProps, mapDispatchToProps)(OrderImagesModal);